
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 20.7C16.8049 20.7 20.7 16.8049 20.7 12C20.7 7.19512 16.8049 3.3 12 3.3C7.19512 3.3 3.3 7.19512 3.3 12C3.3 16.8049 7.19512 20.7 12 20.7ZM12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5Z","fill":"#16171F"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.0351 18.6304C14.8236 17.0266 15.3625 14.6848 15.3625 12C15.3625 9.31521 14.8236 6.97336 14.0351 5.36958C13.1893 3.64933 12.3606 3.3 12 3.3C11.6394 3.3 10.8107 3.64933 9.96488 5.36958C9.17636 6.97336 8.63751 9.31521 8.63751 12C8.63751 14.6848 9.17636 17.0266 9.96488 18.6304C10.8107 20.3507 11.6394 20.7 12 20.7C12.3606 20.7 13.1893 20.3507 14.0351 18.6304ZM12 22.5C14.8512 22.5 17.1625 17.799 17.1625 12C17.1625 6.20101 14.8512 1.5 12 1.5C9.14883 1.5 6.83751 6.20101 6.83751 12C6.83751 17.799 9.14883 22.5 12 22.5Z","fill":"#16171F"}}),_c('ellipse',{attrs:{"cx":"12","cy":"12","rx":"5.16249","ry":"10.5","fill":"#5D5CFD"}}),_c('rect',{attrs:{"x":"2.03784","y":"11.1","width":"19.7031","height":"1.8","fill":"#16171F"}})])
          )
        }
      }
    